export const todaysFeaturedExercise = {
  date: new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
  mainExercise: {
    name: 'Barbell Back Squat',
    sets: '5 sets',
    reps: '5 reps',
    rest: '3-4 minutes',
    description: 'The king of all exercises for building lower body strength and mass. Focus on depth, maintaining a neutral spine, and driving through your heels.',
    tips: ['Keep chest up and core braced', 'Break at hips and knees simultaneously', 'Drive knees out over toes', 'Full depth with control'],
    videoUrl: '#',
  },
  assistanceExercise: {
    name: 'Bulgarian Split Squats',
    sets: '3 sets',
    reps: '10 reps per leg',
    rest: '90 seconds',
    description: 'Unilateral leg exercise to address imbalances and build single-leg strength.',
    tips: ['Front shin vertical', 'Control the descent', 'Drive through front heel'],
  },
  mealPlan: {
    breakfast: {
      name: 'Protein Power Bowl',
      calories: 620,
      protein: '48g',
      carbs: '52g',
      fats: '24g',
      items: ['4 whole eggs scrambled', '1 cup oatmeal', '1/2 cup blueberries', '1 tbsp almond butter', 'Black coffee'],
    },
    lunch: {
      name: 'Grilled Chicken & Quinoa',
      calories: 680,
      protein: '54g',
      carbs: '62g',
      fats: '18g',
      items: ['8oz grilled chicken breast', '1 cup quinoa', '2 cups mixed vegetables', 'Olive oil drizzle', 'Lemon herb seasoning'],
    },
    preworkout: {
      name: 'Energy Boost',
      calories: 280,
      protein: '8g',
      carbs: '48g',
      fats: '6g',
      items: ['1 banana', '2 rice cakes', '1 tbsp peanut butter', 'Green tea'],
    },
    postworkout: {
      name: 'Recovery Shake',
      calories: 420,
      protein: '42g',
      carbs: '48g',
      fats: '8g',
      items: ['2 scoops whey protein', '1 cup almond milk', '1 banana', '1 tbsp honey', 'Ice'],
    },
    dinner: {
      name: 'Salmon & Sweet Potato',
      calories: 720,
      protein: '46g',
      carbs: '58g',
      fats: '28g',
      items: ['8oz wild salmon', '1 large sweet potato', '2 cups broccoli', 'Avocado oil', 'Garlic herb seasoning'],
    },
  },
  peptideCombination: {
    goal: 'Muscle Growth & Recovery',
    stack: ['BPC-157 (250mcg)', 'TB-500 (2mg)', 'Ipamorelin (200mcg)'],
    timing: ['BPC-157: Post-workout', 'TB-500: Before bed', 'Ipamorelin: Morning fasted'],
    benefits: 'This combination supports enhanced recovery, tissue repair, and growth hormone optimization for maximum muscle building and injury prevention.',
  },
};

export const weeklyExercises = [
  { day: 'Monday', focus: 'Lower Body Power', main: 'Barbell Back Squat', assistance: 'Bulgarian Split Squats' },
  { day: 'Tuesday', focus: 'Upper Body Push', main: 'Barbell Bench Press', assistance: 'Incline Dumbbell Press' },
  { day: 'Wednesday', focus: 'Active Recovery', main: 'Light Cardio', assistance: 'Mobility Work' },
  { day: 'Thursday', focus: 'Lower Body Hypertrophy', main: 'Romanian Deadlift', assistance: 'Leg Press' },
  { day: 'Friday', focus: 'Upper Body Pull', main: 'Weighted Pull-ups', assistance: 'Barbell Rows' },
  { day: 'Saturday', focus: 'Full Body Conditioning', main: 'Kettlebell Complexes', assistance: 'Core Circuit' },
  { day: 'Sunday', focus: 'Rest & Recovery', main: 'Stretching', assistance: 'Foam Rolling' },
];